import styled from 'styled-components';
import { StyledProps } from 'types/styles';
import {
  Container as StyledContainer,
  Row as StyledRow,
  Col as StyledCol,
  Hidden as StyledHidden,
  Visible as StyledVisible,
} from 'react-awesome-styled-grid';
import {
  typography,
  color,
  space,
  position,
  flexbox,
  layout,
  border,
  zIndex,
  background,
  borderRadius,
  shadow,
  display,
  system,
} from 'styled-system';

interface Props extends StyledProps {
  gap?: number | string | Array<number | string>;
}

const gapSystem = system({
  gap: {
    property: 'gap',
    scale: 'space',
  },
});

export const Container = styled(StyledContainer)<Props>`
  ${layout}
  ${color}
  ${space}
  ${border}
`;

export const Row = styled(StyledRow)<Props>`
  ${border}
  ${space}
  ${color}
  ${layout}
  ${position}
  ${flexbox}
  flex: 0 1 auto;
  flex-shrink: 0;
`;

export const Col = styled(StyledCol)<Props>`
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}
  ${border}
`;

export const Hidden = styled(StyledHidden)``;

export const Visible = styled(StyledVisible)``;

export const Div = styled.div<Props>`
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${shadow}
  ${display}
  ${border}
  ${position}
  ${typography}
  ${borderRadius}
  ${zIndex}
`;

export const ImageWrapper = styled.img<Props>`
  ${border}
  ${space}
  ${layout}
`;

export const FlexRow = styled.div<Props>`
  display: flex;
  width: 100%;

  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}
  ${gapSystem}
`;

FlexRow.defaultProps = {
  flexDirection: ['row'],
};

export const FlexCol = styled.div<Props>`
  display: flex;
  flex-direction: column;
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${display}
  ${gapSystem}
`;

export const IconWrapper = styled.div<Props>`
  ${color}
  ${space}
  ${flexbox}
  ${background}
  ${layout}
  ${shadow}
  ${display}
  ${border}
  ${position}
  ${typography}
  ${zIndex}

  svg {
    ${layout}
  }
`;
